import React, { useEffect, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import axios from "axios";
import ProductCard from "../components/ProductCard";
import Spinner from "../components/Spinner";

//
const Home = () => {
  const [product, setProduct] = useState([]);
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true); // Iniciar o loading

      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product`
        );
        setProduct(response.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // Finalizar o loading após a requisição
      }
    };

    fetchProducts();
  }, []);

  // const latestProducts = product.slice().reverse().slice(0, 3);
  const latestProducts = product.filter(
    (foto) =>
      foto.tags.toLowerCase().includes("brinde") &&
      !foto.tags.toLowerCase().includes("oculta")
  );

  return (
    <div className="p-4 max-w-[1300px] mx-auto mt-16">
      <div className="hero-content text-center mb-18">
        <div className="max-w-md">
          <h1 className="text-3xl font-bold">
            Welcome to my <span className="text-teal-700">Marketplace</span>
          </h1>
          <p className="py-4">
            Um lugar criado especialmente para você colecionar suas melhores
            lembranças no vôlei.
          </p>
          <NavLink to="/ar/shop" className="btn btn-accent">
            Ir para a loja
          </NavLink>
          {loading && <Spinner />}
        </div>
      </div>

      <ProductCard product={latestProducts} />
      {/* Posso mostrar, mas filtro antes, só com campo "Amostra". Preciso criar no banco de dados e no card para filtrar. O filtro é no topo dessa página. */}
      <div className="hero-content text-center mb-8">
        <NavLink to="/ar/shop" className="btn btn-accent">
          Ir para a loja
        </NavLink>
      </div>
    </div>
  );
};

export default Home;
